"use client";

import React, { useState } from "react";
import MerchantFaqsAccordion from "./MerchantFaqsAccordion";

interface Props {
    faqs: any[];
    initialCount?: number;
}

const FaqShowMore = ({ faqs, initialCount = 8 }: Props) => {
    const [showAll, setShowAll] = useState(false);

    const visibleFaqs = showAll ? faqs : faqs.slice(0, initialCount);
    const hasMore = faqs.length > initialCount;

    return (
        <div className="space-y-3">
            {visibleFaqs.map((faq: any, idx: number) => (
                <MerchantFaqsAccordion key={idx} faq={faq} index={idx} />
            ))}

            {hasMore && (
                <div className="mt-5 flex justify-center">
                    <button
                        onClick={() => setShowAll((prev) => !prev)}
                        className="inline-flex items-center gap-2 px-8 py-3.5 rounded-2xl bg-gray-900 hover:bg-blue-600 hover:border-blue-600 text-white hover:text-white text-base font-bold transition-all duration-200 group shadow-sm"
                    >
                        {showAll ? (
                            <>
                                Show Less
                            </>
                        ) : (
                            <>
                                Show More
                            </>
                        )}
                    </button>
                </div>
            )}
        </div>
    );
};

export default FaqShowMore;
